import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  let error = ``;
  if (this.state.storageAccessError) {
    error = this.state.storageAccessError;
  } else if (this.state.attemptConnectionError) {
    error = this.state.attemptConnectionError;
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".auth-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".auth-login-header"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".mp-logo-svg",
    attrs: { icon: `mixpanel-logo` }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".auth-login-header-text"
  }, "Connect to Mixpanel")), /* @__PURE__ */ jsx("div", {
    sel: ".auth-login-cta"
  }, "Once logged in, you and anyone else logged in who has access to this page in Mixpanel, will see interactive, rich content that updates live."), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".auth-login-button",
    attrs: {
      size: ButtonSize.Large,
      theme: ButtonTheme.Primary,
      elref: `embedLoginButton`
    },
    on: { click: () => this.handleLoginButtonClick() }
  }, "Log in"), this.state.showAuthButtonFallback && /* @__PURE__ */ jsx("div", {
    sel: ".auth-button-fallback"
  }, "Button not working? Visit", ` `, /* @__PURE__ */ jsx("a", {
    attrs: {
      href: `/embed/connect?code=${encodeURIComponent(this.state.code)}`,
      target: `_blank`
    }
  }, "https://mixpanel.com/embed/connect"), ` `, "in a new browser window and enter code:", ` `, /* @__PURE__ */ jsx("span", {
    sel: ".auth-fallback-code"
  }, this.state.code)), error);
}
